import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-dialog',
  imports: [
    MatDialogModule,
    MatButtonModule,
  ],
  templateUrl: './confirm-dialog.html',
  styleUrl: './confirm-dialog.scss'
})
export class ConfirmDialog {
  readonly dialogRef = inject(MatDialogRef<ConfirmDialog>);
  readonly data = inject<{ title?: string; message?: string }>(MAT_DIALOG_DATA, { optional: true }) ?? {};

  get title(): string {
    return this.data.title ?? 'Warning';
  }

  get message(): string {
    return this.data.message ?? 'Are you sure you want to do this action?';
  }

}
